export const LANGUAGES = [
  { label: 'English', languageCode: 'en' },
  { label: 'German', languageCode: 'de' },
  { label: 'Spanish', languageCode: 'es' },
  { label: 'French', languageCode: 'fr' },
  { label: 'Portuguese', languageCode: 'pt' },
  { label: 'Russian', languageCode: 'ru' }
]

export const MAXIMUM_NUMBER_OF_AUTO_BETS = 50

/* ==========================================================================
  HTTP Method Types
========================================================================== */
export const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
export const TOKEN = 'gamma_poker_auth_token'
export const LANGUAGE = 'gamma_poker_language'
export const OPERATOR_ID = 'gamma_poker_operator_id'
export const ROLE = 'gamma_poker_operator_role'

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
export const ROUTE_PATHS = {
  home: '/',
  holdem: '/holdem',
  plo4: '/plo4',
  plo5: '/plo5',
  plo6: '/plo6',
  leaderboard: '/leaderboard',
  tournamentInfo: '/tournament-info',
  gameRules: '/rules/:gameId'
}

/* ==========================================================================
Loader types
========================================================================== */
export const LOADER = {
  BUTTON: 'button',
  CONTENT: 'content',
  TABLE_CELL: 'tableCell'
}

/* ==========================================================================
  Loader Types
========================================================================== */
export const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  Game Ids
========================================================================== */
export const DEFAULT_GAME_ID = {
  HOLDEM: 1,
  PLO4: 2,
  PLO5: 3,
  PLO6: 4,
  SHORT_DECK: 5,
  TOURNAMENT: 6
}

/* ==========================================================================
  Game Result
========================================================================== */
export const BET_RESULT = {
  WON: 'won',
  LOST: 'lost',
  CANCELLED: 'cancelled'
}

export const S3_BUCKET_ENDPOINT = 'https://gs-custom-games-storage.s3.amazonaws.com'

export const S3_BUCKET_ENDPOINT_FAST_GAMES = 'https://fastgames-dev-storage.s3.amazonaws.com'

export const DEFAULT_PAGE_CALLS = 10

/* ==========================================================================
  Currency Symbols
========================================================================== */
export const CURRENCY_SYMBOL = {
  USD: '$'
}

export const CURRENCIES = {
  USD: { isFiat: true, precision: 2, symbol: '$', label: 'United States Dollar', value: 'USD', fileName: '09_usdc.svg' }
}

export const DEFAULT_BET_AMOUNT = '5.00'

export const CURRENCIES_ID = {
  1: 'USD',
  2: 'USD',
  3: 'USD'
}

export const WALLET_EMIT_TYPES = {
  CREDIT: 'credit',
  DEBIT: 'debit',
  RESOLVE: 'resolve',
  DEFAULT: 'default'
}

export const ROUTE_GAME_NAME_ID = {
  [ROUTE_PATHS.holdem]: DEFAULT_GAME_ID.HOLDEM,
  [ROUTE_PATHS.plo4]: DEFAULT_GAME_ID.PLO4,
  [ROUTE_PATHS.plo5]: DEFAULT_GAME_ID.PLO5,
  [ROUTE_PATHS.plo6]: DEFAULT_GAME_ID.PLO6
}
